import React from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { BasicSectionTitle } from 'Components/Blocks/Titles'
import { Column, Row } from 'Components/UI'

import { LANDING_CONTENT_PX, LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

import Gallery from './Gallery'

type Props = {
  onAction?: () => void
}

function LearnSection({ onAction }: Props) {
  return (
    <SectionContainer px={LANDING_CONTENT_PX}>
      <AppearingWrapper centered>
        <Column fullWidth gap={10} maxWidth={LANDING_CONTENT_WIDTH_PX} pt={64}>
          <BasicSectionTitle
            buttonCaption="Join Us Today"
            plainText="Emajin who you’ll share the course with next."
            subtitle="It only takes one round of golf to change the future of your business."
            title="learn"
            onClick={onAction}
          />

          <Row fullWidth justifyCenter>
            <Gallery />
          </Row>
        </Column>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default LearnSection
